import { render, staticRenderFns } from "./TagsShow.vue?vue&type=template&id=60550da6&scoped=true&"
import script from "./TagsShow.vue?vue&type=script&lang=js&"
export * from "./TagsShow.vue?vue&type=script&lang=js&"
import style0 from "./TagsShow.vue?vue&type=style&index=0&id=60550da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60550da6",
  null
  
)

export default component.exports